import SitePageCardsAdmin from "@/project/jain_elibrary-admin/pages/content/SitePageCardsAdmin";

const ContactUs = () => (
  <SitePageCardsAdmin pageSlug="contact" heading="Contact Us (site)" />
);

export default ContactUs;
